import { useLogin } from "@/hooks/useLogin";
import { Box, Button, Divider, HStack, Text, VStack } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { IconUserProfile } from "@/components/icons/userProfile";
import { IconLogout } from "@/components/icons/logout";

export const MenuPopUp = () => {
  const { removeAuthentication, getAccount } = useLogin();
  const navigate = useNavigate();

  const account = getAccount();

  return (
    <VStack
      position="absolute"
      w="180px"
      top="48px"
      right={2}
      bg="neutral.600"
      border="1px solid"
      borderColor="whiteAlpha.100"
      borderRadius={8}
      boxShadow="0 8px 32px rgba(0,0,0,0.45), 0 2px 8px rgba(0,0,0,0.3)"
      alignItems="stretch"
      spacing={0}
      overflow="hidden"
      zIndex={1000}
      py={1}
    >
      {/* ── Cabeçalho com nome do usuário ── */}
      <Box
        px={4}
        py={3}
        borderBottom="1px solid"
        borderBottomColor="whiteAlpha.80"
      >
        <Text
          fontFamily="Inter"
          fontWeight="600"
          fontSize="12px"
          color="neutral.50"
          noOfLines={1}
        >
          {account?.name ?? "Usuário"}
        </Text>
      </Box>

      {/* ── Meu Perfil ── */}
      <Button
        variant="ghost"
        w="100%"
        h="38px"
        px={4}
        borderRadius={0}
        justifyContent="flex-start"
        color="neutral.200"
        fontFamily="Inter"
        fontWeight="500"
        fontSize="13px"
        _hover={{ bg: "whiteAlpha.100", color: "neutral.0" }}
        _active={{ bg: "whiteAlpha.150" }}
        onClick={() => navigate(`/usuario/editar/${account!.id}`)}
      >
        <HStack spacing={3}>
          <Box color="neutral.300">
            <IconUserProfile />
          </Box>
          <Text>Meu Perfil</Text>
        </HStack>
      </Button>

      <Divider borderColor="whiteAlpha.80" />

      {/* ── Sair ── */}
      <Button
        variant="ghost"
        w="100%"
        h="38px"
        px={4}
        borderRadius={0}
        justifyContent="flex-start"
        color="red.400"
        fontFamily="Inter"
        fontWeight="500"
        fontSize="13px"
        _hover={{ bg: "red.900", color: "red.300" }}
        _active={{ bg: "red.800" }}
        onClick={() => {
          removeAuthentication();
          navigate("/login");
        }}
      >
        <HStack spacing={3}>
          <IconLogout />
          <Text>Sair</Text>
        </HStack>
      </Button>
    </VStack>
  );
};
